export default __webpack_public_path__ + "static/media/albufissapic1.92cbcfa7.jpg";